import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('accMgmt.tenant.deleteConfirmation'),
      "open": _vm.open,
      "color": "red",
      "buttons": [{
        text: this.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }, {
        dataCy: 'button_delete',
        text: _vm.deleteButtonText,
        color: 'red',
        emit: 'delete',
        disabled: _vm.deleteBtnDisabled
      }]
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('cancel');
      },
      "delete": _vm.handleDeleteAction
    }
  }, [!_vm.accountInformationFetched ? _c('div', [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column justify-center align-center p-3"
  }, [_c(VProgressCircular, {
    attrs: {
      "indeterminate": "",
      "color": _vm.color,
      "size": 50
    }
  })], 1)])], 1)], 1) : _vm._e(), _vm.accountInformationFetched && !_vm.accountInformationError ? _c('div', [_vm.accountVirtualDeviceIds.length ? _c(VAlert, {
    attrs: {
      "icon": "fas fa-exclamation-circle",
      "color": "#ff5500",
      "density": "compact",
      "theme": "dark"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('accMgmt.tenant.virtualDevicesFound', {
    n: _vm.accountVirtualDeviceIds.length
  })) + "\n      "), _c('p', {
    staticClass: "mt-0 mb-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('accMgmt.tenant.deleteConfirmationTextVirtualDevices')) + "\n      ")])]) : _vm._e(), _vm.containsDeviceDriverUsedByOtherAccount ? _c(VAlert, {
    attrs: {
      "icon": "fas fa-exclamation-circle",
      "color": "#ff5500",
      "density": "compact",
      "theme": "dark"
    }
  }, [_c('p', {
    staticClass: "mt-0 mb-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('accMgmt.tenant.deleteConfimationDeviceDriversUsedInOtherAccount')) + "\n      ")])]) : _vm._e(), _vm.hasSubAccounts ? _c(VAlert, {
    attrs: {
      "icon": "fas fa-exclamation-circle",
      "color": "#ff5500",
      "density": "compact",
      "theme": "dark"
    }
  }, [_c('p', {
    staticClass: "mt-0 mb-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('accMgmt.tenant.accountHasSubaccounts')) + "\n      ")])]) : _vm._e(), _c('div', {
    staticClass: "accountInfoBox"
  }, [_c('span', {
    staticClass: "accountNameInfo"
  }, [_vm._v(_vm._s(_vm.accountInformation.account.name))]), _c('br'), _c(VTreeview, {
    staticClass: "infoTree",
    attrs: {
      "items": _vm.subAccountTree,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function ({
        item
      }) {
        return [_vm._v("\n          " + _vm._s(item.name) + "\n          "), item.id ? _c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(item.id) + ")")]) : _vm._e()];
      }
    }], null, false, 651627857)
  }), _c(VTreeview, {
    staticClass: "infoTree",
    attrs: {
      "items": _vm.digitalTwinsTree,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function ({
        item
      }) {
        return [item.id ? [_c('a', {
          attrs: {
            "href": `/#/digitaltwin-mgmt/${item.id}`,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(item.title))])] : [_vm._v("\n            " + _vm._s(item.title) + "\n          ")], _vm._v("\n           \n          "), item.id ? _c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(item.id) + ")")]) : _vm._e()];
      }
    }], null, false, 2050145399)
  }), _c(VTreeview, {
    staticClass: "infoTree",
    attrs: {
      "items": _vm.deviceDriversTree,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function ({
        item
      }) {
        return [item.id ? [_c('a', {
          attrs: {
            "href": `/#/virtual-device-drivers/${item.id}`,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(item.title))])] : [_vm._v("\n            " + _vm._s(item.title) + "\n          ")], _vm._v("\n           \n          "), item.id ? _c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(item.id) + ")")]) : _vm._e()];
      }
    }], null, false, 2137409987)
  }), _c(VTreeview, {
    staticClass: "infoTree",
    attrs: {
      "items": _vm.deviceTemplatesTree,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function ({
        item
      }) {
        return [item.id ? [_c('a', {
          attrs: {
            "href": `/#/device-templates/${item.id}`,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(item.DraftVersion.title))])] : [_vm._v("\n            " + _vm._s(item.title) + "\n          ")], _vm._v("\n           \n          "), item.id ? _c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(item.id) + ")")]) : _vm._e()];
      }
    }], null, false, 1450747728)
  })], 1), _vm.accountVirtualDeviceIds.length ? _c(VCheckbox, {
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceDeleteRemotely'),
      "color": _vm.color,
      "hide-details": ""
    },
    model: {
      value: _vm.deleteVirtualDevicesInRemoteSystem,
      callback: function ($$v) {
        _vm.deleteVirtualDevicesInRemoteSystem = $$v;
      },
      expression: "deleteVirtualDevicesInRemoteSystem"
    }
  }) : _vm._e(), _c(VTextField, {
    staticClass: "pt-4",
    attrs: {
      "dense": "",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.accountVirtualDeviceIds.length ? _vm.$i18n_t('accMgmt.tenant.enterNumberOfVirtualDevices') : _vm.$i18n_t('accMgmt.tenant.accountIdText'),
      "data-cy": "input_confirmation"
    },
    model: {
      value: _vm.confirmationInput,
      callback: function ($$v) {
        _vm.confirmationInput = $$v;
      },
      expression: "confirmationInput"
    }
  })], 1) : _vm._e(), _vm.accountInformationError ? _c('div', {
    staticClass: "accountInfoBox"
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('accMgmt.tenant.deleteConfirmationError')) + "\n  ")]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };